// extracted by mini-css-extract-plugin
export default {"shadowBox":"zGG8H0c4","inverted":"_15V4pxhy"};